import QuantityActionTypes from 'yoda-site-components/lib/actionTypes/QuantityActionTypes';

const { BUNDLE_QUANTITY_ON_CHANGE, BUNDLE_QUANTITY_ON_RESET } = QuantityActionTypes;

function QuantityReducer(state = {}, { type, payload }) {
    switch (type) {
        case BUNDLE_QUANTITY_ON_CHANGE:
            return { ...state, ...payload };
        case BUNDLE_QUANTITY_ON_RESET:
            return { ...state, [payload]: undefined };
        default:
            return state;
    }
}

QuantityReducer.reducerName = 'bundleQuantity';

export default QuantityReducer;
